import { WorkItem } from "@buzzeasy/shared-frontend-utilities";
import { PropsWithChildren, ReactElement, useCallback, useState } from "react";
import { WorkItemInfo, WorkItemInfoContext } from "./WorkItemInfoContext";

type WorkItemId = WorkItem["workItemId"];

/**
 * Provides extra information for workItems.
 *
 * **No provider dependencies**
 */
export default function WorkItemInfoProvider({ children }: PropsWithChildren): ReactElement {
  const [workItemInfoDict, setWorkItemInfoDict] = useState<Record<WorkItemId, WorkItemInfo | undefined>>({});

  const setInfo = useCallback(
    (wId: WorkItemId, info: WorkItemInfo | ((currentInfo: WorkItemInfo | undefined) => WorkItemInfo)) => setWorkItemInfoDict(curr => ({
      ...curr,
      [wId]: typeof info === "function" ? info(curr[wId]) : info,
    })),
    [],
  );

  const removeInfo = useCallback(
    (wId: WorkItemId) => setWorkItemInfoDict((curr) => {
      const newDict = { ...curr };
      delete newDict[wId];
      return newDict;
    }),
    [],
  );

  return (
    <WorkItemInfoContext.Provider value={{ workItemInfoDict, setInfo, removeInfo }}>
      {children}
    </WorkItemInfoContext.Provider>
  );
}
